import { render, staticRenderFns } from "./teamChatItem.vue?vue&type=template&id=3e11f579&"
import script from "./teamChatItem.vue?vue&type=script&lang=js&"
export * from "./teamChatItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports